module.exports = __webpack_public_path__ + "img/1440.5e4067f1.jpg";